import styled from 'styled-components';

export const EditableCellWrap = styled.div`
  padding: 0 24px;
  cursor: pointer;
  border: 1px dashed var(--primary-color);
  color: var(--primary-color);
  min-height: 16px;
`;
